import { func, instanceOf, oneOfType, shape } from 'prop-types';

export const refProptype = oneOfType([func, shape({ current: instanceOf(Element) })]);
